<template>
  <div>
    <va-card>
      <template slot="header">
        <div class="va-card__header-title" color="secondary">
          <router-link to="/">{{ $t('menu.dashboard') }}</router-link> / <router-link to="/rezervasyon/listesi">{{ $t('menu.rents') }}</router-link> / {{ item.code }}
        </div>
        <div class="va-card__header-actions"/>
      </template>
    </va-card>
    <!-- RENT -->
    <div class="row">
      <div class="flex xs12 md10 offset--md1">
        <va-card 
          class="rent-detail__info"
          stripe="secondary"
          :title="item.code + ' Rezervasyon Bilgileri'"
        >
          <template slot="actions">
            <va-badge :color="getStatusColor()">
              {{ getStatusReadable(item.status) }}
            </va-badge>
          </template>
          <div class="row">
            <div class="flex md6 xs12">
              <div class="grid__container flex-center">
                <va-list fit class="va-list__pickup">
                 <va-list-label>Alım</va-list-label>
                  <va-item>
                    <va-item-section side>
                      <va-icon name="fa fa-map-marker" color="red" />
                    </va-item-section>
                    <va-item-section>
                      <va-item-label>{{item.pickup_region.name_readable}}</va-item-label>
                    </va-item-section>
                  </va-item>
                  <va-item>
                    <va-item-section side>
                      <va-icon name="fa fa-calendar-o" color="red" />
                    </va-item-section>
                    <va-item-section>
                      <va-item-label>{{item.pickup_time_readable.date}}</va-item-label>
                    </va-item-section>
                  </va-item>
                  <va-item>
                    <va-item-section side>
                      <va-icon name="fa fa-clock-o" color="red" />
                    </va-item-section>
                    <va-item-section>
                      <va-item-label>{{item.pickup_time_readable.time}}</va-item-label>
                    </va-item-section>
                  </va-item>
                </va-list>
              </div>
            </div>
            <div class="flex md6 xs12">
              <div class="grid__container flex-center">
                <va-list fit class="va-list__dropoff">
                 <va-list-label>Teslim</va-list-label>
                  <va-item>
                    <va-item-section side>
                      <va-icon name="fa fa-map-marker" color="red" />
                    </va-item-section>
                    <va-item-section>
                      <va-item-label>{{item.dropoff_region.name_readable}}</va-item-label>
                    </va-item-section>
                  </va-item>
                  <va-item>
                    <va-item-section side>
                      <va-icon name="fa fa-calendar-o" color="red" />
                    </va-item-section>
                    <va-item-section>
                      <va-item-label>{{item.dropoff_time_readable.date}}</va-item-label>
                    </va-item-section>
                  </va-item>
                  <va-item>
                    <va-item-section side>
                      <va-icon name="fa fa-clock-o" color="red" />
                    </va-item-section>
                    <va-item-section>
                      <va-item-label>{{item.dropoff_time_readable.time}}</va-item-label>
                    </va-item-section>
                  </va-item>
                </va-list>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="flex xs12 md6 offset--md3">
              <va-list fit class="py-0">
                <va-item>
                  <va-item-section side>
                    <va-item-label>Araç</va-item-label>
                  </va-item-section>
                  <va-item-section class="text--right">
                    <va-item-label>
                      {{item.prices.vehicle}}
                      <va-icon color="gray" name="" size="md" class="appended">₺</va-icon>
                    </va-item-label>
                  </va-item-section>
                </va-item>
                <va-item v-if="!!item.prices.extras">
                  <va-item-section side>
                    <va-item-label>Ekstralar</va-item-label>
                  </va-item-section>
                  <va-item-section class="text--right">
                    <va-item-label>
                      {{item.prices.extras}}
                      <va-icon color="gray" name="" size="md" class="appended">₺</va-icon>
                    </va-item-label>
                  </va-item-section>
                </va-item>
                <va-item>
                  <va-item-section side>
                    <va-item-label>Toplam</va-item-label>
                  </va-item-section>
                  <va-item-section class="text--right">
                    <va-item-label>
                      {{item.prices.total}}
                      <va-icon color="gray" name="" size="md" class="appended">₺</va-icon>
                    </va-item-label>
                  </va-item-section>
                </va-item>
              </va-list>
            </div>
          </div>
        </va-card>
      </div>
    </div>
    <!-- VEHICLE -->
    <div class="row">
      <div class="flex md6 xs12">
        <!-- VEHICLE DETAIL INFO -->
        <va-card 
          class="vehicle-detail__info"
          overlay
          titleOnImage
          :image="!!item.vehicle.images_readable && item.vehicle.images_readable.length > 0 ? item.vehicle.images_readable[0] : ''"
          :title="item.vehicle.name_readable"
        >
          <template slot="actions">
            <va-badge color="secondary">{{!!item.vehicle.segment ? item.vehicle.segment.name_readable : ''}}</va-badge>
          </template>
          <div v-if="!!item.vehicle.images_readable && item.vehicle.images_readable.length > 1" class="pt-3">
            <carousel :perPage="1" :autoplay="true" :autoplayHoverPause="true">
              <slide v-for="(img, index) in item.vehicle.images_readable" :key="index" class="text--center">
                <img :src="img"/>
              </slide>
            </carousel>
          </div>
        </va-card>
      </div>
      <div class="flex md6 xs12">
        <!-- VEHICLE DETAIL PROPERTIES-->
        <va-card
          class="vehicle-detail__properties"
          stripe="secondary"
          title="Özellikler"
        >
          <va-list fit class="py-0" style="border: none; box-shadow: none;">
            <va-item>
              <va-item-section side>
                <va-item-label>Ücretsiz km Hakkı</va-item-label>
              </va-item-section>
              <va-item-section class="text--right">
                <va-item-label>{{item.vehicle.daily_free_km}}<va-icon color="gray" class="appended">km/gün</va-icon></va-item-label>
              </va-item-section>
            </va-item>
            <template v-for="(val, key) in item.vehicle.properties">
              <va-item :key="key">
                <va-item-section side>
                  <va-item-label>
                    {{ getPropertyLabel(key) }}
                  </va-item-label>
                </va-item-section>
                <va-item-section class="text--right">
                  <va-item-label>
                    {{ getPropertyReadable(key,val) }}
                  </va-item-label>
                </va-item-section>
              </va-item>
            </template>
          </va-list>
        </va-card>
        <!-- VEHICLE DETAIL EXTRAS -->
        <va-card
          v-if="!!item.extras && item.extras.length>0"
          class="vehicle-detail__extras mt-3"
          stripe="secondary"
          title="Seçili Ekstralar"
        >
          <va-list fit class="py-0" style="border: none; box-shadow: none;">
            <template v-for="(val, i) in item.extras">
              <va-item :key="i">
                <va-item-section side>
                  <va-item-label>
                    {{ val.extra.name_readable }}
                  </va-item-label>
                </va-item-section>
                <va-item-section class="text--right">
                  <va-item-label>
                    <small>
                      {{ val.price }}
                      <va-icon color="gray" name="" size="md" class="appended">₺/gün</va-icon>
                    </small>
                    <b>
                      x {{ val.quantity }}
                    </b>
                  </va-item-label>
                </va-item-section>
              </va-item>
              <va-list-separator v-if="i < item.prices.length - 1" :key="'separator' + i" />
            </template>
          </va-list>
        </va-card>
      </div>
    </div>
    <!-- USER -->
    <div class="row">
      <div class="flex md6 xs12">
        <!-- DRIVER INFO-->
        <va-card
          class="user-detail__info"
          stripe="secondary"
          title="Sürücü Bilgileri"
        >
          <va-list fit class="py-0" style="border: none; box-shadow: none;">
            <va-item v-if="!!item.driver.fullname">
              <va-item-section side>
                <va-item-label><va-icon name="fa fa-drivers-license"/></va-item-label>
              </va-item-section>
              <va-item-section class="text--right">
                <va-item-label>{{item.driver.fullname}}</va-item-label>
              </va-item-section>
            </va-item>
            <va-item v-if="!!item.driver.mobile">
              <va-item-section side>
                <va-item-label><va-icon name="fa fa-phone"/></va-item-label>
              </va-item-section>
              <va-item-section class="text--right">
                <va-item-label>{{item.driver.mobile}}</va-item-label>
              </va-item-section>
            </va-item>
            <va-item v-if="!!item.driver.email">
              <va-item-section side>
                <va-item-label><va-icon name="fa fa-envelope"/></va-item-label>
              </va-item-section>
              <va-item-section class="text--right">
                <va-item-label>{{item.driver.email}}</va-item-label>
              </va-item-section>
            </va-item>
          </va-list>
        </va-card>
      </div>
      <div class="flex md6 xs12">
        <!-- USER INFO-->
        <va-card
          class="user-detail__info"
          stripe="secondary"
          title="Müşteri Bilgileri"
        >
          <va-list fit class="py-0" style="border: none; box-shadow: none;">
            <va-item v-if="!!item.user.fullname">
              <va-item-section side>
                <va-item-label><va-icon name="fa fa-user"/></va-item-label>
              </va-item-section>
              <va-item-section class="text--right">
                <va-item-label>{{item.user.fullname}}</va-item-label>
              </va-item-section>
            </va-item>
            <va-item v-if="!!item.user.mobile">
              <va-item-section side>
                <va-item-label><va-icon name="fa fa-phone"/></va-item-label>
              </va-item-section>
              <va-item-section class="text--right">
                <va-item-label>{{item.user.mobile}}</va-item-label>
              </va-item-section>
            </va-item>
            <va-item v-if="!!item.user.email">
              <va-item-section side>
                <va-item-label><va-icon name="fa fa-envelope"/></va-item-label>
              </va-item-section>
              <va-item-section class="text--right">
                <va-item-label>{{item.user.email}}</va-item-label>
              </va-item-section>
            </va-item>
          </va-list>
        </va-card>
      </div>
    </div>
    <div class="row">
      <div class="flex md6 xs12">
        <!-- BILLING INFO -->
        <va-card
          v-if="item.invoice.is_corporate===1"
          class="user-detail__billing"
          stripe="secondary"
          title="Fatura Bilgileri"
        >
          <va-list fit class="py-0" style="border: none; box-shadow: none;">
            <va-item>
              <va-item-section side>
                <va-item-label>Şirket Ünvanı</va-item-label>
              </va-item-section>
              <va-item-section class="text--right">
                <va-item-label>{{item.invoice.billing_title}}</va-item-label>
              </va-item-section>
            </va-item>
            <va-item>
              <va-item-section side>
                <va-item-label>Vergi Dairesi</va-item-label>
              </va-item-section>
              <va-item-section class="text--right">
                <va-item-label>{{item.invoice.billing_token}}</va-item-label>
              </va-item-section>
            </va-item>
            <va-item>
              <va-item-section side>
                <va-item-label>Vergi Numarası</va-item-label>
              </va-item-section>
              <va-item-section class="text--right">
                <va-item-label>{{item.invoice.billing_office}}</va-item-label>
              </va-item-section>
            </va-item>
            <va-item>
              <va-item-section side>
                <va-item-label>Adres</va-item-label>
              </va-item-section>
              <va-item-section class="text--right">
                <va-item-label>{{item.invoice.billing_address}}</va-item-label>
              </va-item-section>
            </va-item>
          </va-list>
        </va-card>
      </div>
    </div>
    <div class="row">
      <div class="flex xs12 text--right">
        <va-button v-if="item.status==='waiting'" color="info" icon="fa fa-check-square-o" @click.stop="confirmUpdateRent('approved')">{{ $t('tables.actions.approve') }}</va-button>
        <va-button v-if="item.status!=='canceled'" color="warning" icon="fa fa-close" @click.stop="confirmUpdateRent('canceled')">{{ $t('tables.actions.cancel') }}</va-button>
      </div>
    </div>
  </div>
</template>

<script>
import { Carousel, Slide } from 'vue-carousel'
import rentServices from '../../services/api/rent'
import responseMixin from '../../services/api/response'
export default {
  mixins: [responseMixin],
  components: {
    Carousel,
    Slide
  },
  data () {
    return {
      item: {
        vehicle: {
          images_readable: []
        }
      },
      statusOptions : [{
          key: 'waiting',
          label: 'Onay Bekliyor'
        }, { 
          key: 'approved',
          label: 'Onaylandı'
        },{ 
          key: 'canceled',
          label: 'İptal Edildi'
        }
      ]
    }
  },
  methods: {
    async getRent(id) {
      const result = await rentServices.get(id, {
        params: {
          'include': 'user,vehicle.segment,invoice,driver'
        }
      });
      if(result.error){
        return ;
      }
      this.item = result.data.data;
    },
    getStatusColor () {
      if (this.item.status === 'approved') {
        return 'success'
      }
      if (this.item.status === 'canceled') {
        return 'danger'
      }
      return 'warning'
    },
    getStatusReadable (status) {
      if (status === 'approved') {
        return 'Onaylandı'
      }
      if (status === 'canceled') {
        return 'İptal Edildi'
      }
      return 'Onay Bekliyor'
    },
    getPropertyLabel(key) {
      if(key == 'transmission') {
        return 'Vites Türü';
      }
      else if(key == 'fuel_type') {
        return 'Yakıt Türü';
      }
      else if(key == 'seat_count') {
        return 'Koltuk Sayısı';
      }
      else if(key == 'door_count') {
        return 'Kapı Sayısı';
      }
      else if(key == 'luggage_size') {
        return 'Bagaj Büyüklüğü';
      }
    },
    getPropertyReadable(key,val) {
      if(val == 'automatic') {
        return 'Otomatik Vites';
      }
      else if(val == 'manuel') {
        return 'Manuel Vites';
      }
      else if(val == 'diesel') {
        return 'Diesel';
      }
      else if(val == 'gas') {
        return 'Benzin';
      }
      else if(key == 'door_count' || key == 'seat_count') {
        return val + ' adet';
      }
      else if(key == 'luggage_size') {
        return val + ' Valiz'
      }
    },
    async updateRent(id, status) {
      const res = await rentServices.put(id, {
        data: {
          status: status
        }
      });
      if(res.error){
        this.responseToast('PUT', 'error', res);
        return ;
      }
      this.responseToast('PUT', 'success');
      this.getRent(id);
    },
    confirmUpdateRent(status) {
      let statusReadable = this.getStatusReadable(status);
      this.$dialog
        .confirm( this.item.code + ' kodlu rezervasyonun durumunu ' + statusReadable + ' olarak değiştirmek üzeresiniz, onaylıyor musunuz?', {
          loader: true,
          okText: "Onayla",
          cancelText: "Vazgeç"
        })
        .then(dialog => {
          this.updateRent(this.item.id, status);
          dialog.close();
        })
        .catch(dialog => {
          dialog.close();
        });
    },
  },
  created () {
    if(this.$route.params.id) {
      this.getRent(this.$route.params.id);
    }
  }
}
</script>

<style lang="scss">
$theme-secondary: #0e3e92;
.grid {
  &__container {
    min-height: 3rem;
    color: $white;
    border-radius: 0.5rem;
    background-color: $theme-secondary;
  }
}
.rent-detail__info {
  .va-list {
    background: none;
    border: none;
    box-shadow: none;
    &.va-list__pickup, &.va-list__dropoff {
      .va-item-label {
        color: $white;
      }
    }
  }
}
.vehicle-detail__info {
  .va-card__image {
    .va-card__image-overlay {
      background-color: rgba(0, 0, 0, 0.2);
    }
  }
  .va-card__header {
    .va-card__header-inner {
      background-color: rgba(0, 0, 0, 0.2);
    }
  }
  &:hover {
    .va-card__image {
      img {
        object-fit: contain;
      }
      .va-card__image-overlay {
        background-color: transparent;
      }
    }
  }
  .va-icon.appended {
    font-size: 1rem;
  }
  .VueCarousel-inner {
    text-align: center;
    img {max-width: 100%; max-height: 300px; width: 100%; height: auto;}
  }
  .VueCarousel-dot-container, .VueCarousel-dot {
    margin: 0!important;
  }
}
.vehicle-detail__pricing {
  .va-item-section.va-item-section--side .va-icon.prepended {
    line-height: 1;
  }
  .va-item-section.va-item-section--side .va-icon.appended {
    font-size: 1rem;
  }
}
.vehicle-detail__extras {
  small{
    font-size: 80%!important;
  }
}
</style>